import type {Person} from "@/scripts/Common";

const createNewPerson = () => {
    const person: Person = {
        id: 0,
        firstName: '',
        lastName: '',
        phoneNumber: '',
        email: ''
    }

    return person;
}

const personFullName = (person: Person) => {
    const firstName = person.firstName ?? '';
    const lastName = person.lastName ?? '';

    if (firstName !== '' && lastName !== '') return `${lastName}, ${firstName}`;

    return firstName || lastName;
}

export {
    createNewPerson,
    personFullName
}
